module.exports = __webpack_public_path__ + "static/media/community.92ab928f.JPG";